// Dependencias
import React, { useContext, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
// import { notificacionSound } from "../../../assets/sounds/notificacion.mp3";

// Contextos
import { SocketContext } from "../../../context/SocketContext";
import { AuthContext } from "../../../context/authContext/authContext";

export const WhatsappBotNotification = () => {
  const { socket } = useContext(SocketContext);
  const {user} = useContext(AuthContext);

  const showToastNotificationFin = (notification) => {
    let texto = `${notification.tripulante} solicita ${notification.accion} de la unidad ${notification.unidad}`;
    if (user.negocio_id === notification.negocio)
    toast(texto, {
      position: "bottom-center",
      // autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const showToastNotificationGo = (notificacionFin) => {
    let texto = `${notificacionFin.notificacion}`;
    toast.success(texto, {
      position: "bottom-center",
      // autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const showToastNotificationSinExito = (notificacionFin) => {
    let texto = `${notificacionFin.notificacion}`;
    toast.error(texto, {
      position: "bottom-center",
      // autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  useEffect(() => {
    if(!socket) return;
    socket.on("Evento_del_bot_para_teleapp", (notificacion) => {
      if (
        notificacion.notificacion === "Apertura finalizada correctamente" 
        && user.negocio_id === notificacion.negocio
      )
        // crearNotificacionLog(notificacion);
        showToastNotificationGo(notificacion);
      if (
        notificacion.notificacion === "El operador No tuvo exito en la apertura de chapa"
        && user.negocio_id === notificacion.negocio
      )
        showToastNotificationSinExito(notificacion);
      if (
        notificacion.notificacion === "La unidad se encuentra en movimiento, ¡apertura denegada!"
        && user.negocio_id === notificacion.negocio
      )
        showToastNotificationSinExito(notificacion);
      if (
        notificacion.notificacion === "La unidad no se encuentra en geocerca de tienda, ¡apertura denegada!"
        && user.negocio_id === notificacion.negocio
      )
        showToastNotificationSinExito(notificacion);
      if (
        notificacion.notificacion === "Unidad no encontrada en bitacora"
        && user.negocio_id === notificacion.negocio
      )
        showToastNotificationSinExito(notificacion);
      if (
        notificacion.notificacion === "Informacion de viajes actualizada"
        && user.negocio_id === notificacion.negocio
      )
        showToastNotificationSinExito(notificacion);
      if (!notificacion.notificacion) {
        showToastNotificationFin(notificacion);
      }

    });
    return () => {
      socket.off('Evento_del_bot_para_teleapp');
  }
  }, [socket]);

  return (
    <>
      <div>
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          // onClick={() => panel()}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </>
  );
};
